<mat-tab-group>
  <mat-tab label="Ny mall">
    <app-new-template-item [templateItems]="templateItems" [persons]="persons" [durations]="durations" [activities]="activities" [destinations]="destinations" [items]="items" (createdTemplateItems)="createdTemplateItems($event)"></app-new-template-item>
  </mat-tab>
  <mat-tab label="Uppdatera mall"><app-edit-template-item [items]="items" [templateItems]="templateItems"></app-edit-template-item></mat-tab>
</mat-tab-group>

